import { render } from "./NextClasses.vue?vue&type=template&id=f1860710"
import script from "./NextClasses.vue?vue&type=script&lang=js"
export * from "./NextClasses.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__